import InputLabel from '@mui/material/InputLabel';
import MenuItem from "@mui/material/MenuItem";
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Backdrop from '@mui/material/Backdrop';
import Link from '@mui/material/Link';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { ToastContainer, toast } from 'react-toastify';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import '../../assets/style/style.css';
import CircularProgress from '@mui/material/CircularProgress';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import configurationContext  from "contextConfig";
import { useParams, useNavigate } from 'react-router-dom';
import { useMaterialUIController, setOrderContext } from "context";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import DataTable from "layouts/Tables/DataTable";
import Config from "../../config.js";
import { useEffect, useState, useContext } from "react";
import axios from "axios";
import { handleErrors, checkPrivilege } from "common.js";
import { useTranslation } from "react-i18next";
import { PRIVILEGE } from "constants.js";


function List() {

  const [controller, dispatch, initialState] = useMaterialUIController();
  const { orderContext }       = controller;
  const adminType              = localStorage.getItem("type");
  
  const orderBy       = orderContext.orderBy;
  const orderByType   = orderContext.orderByType;
  const filterBy      = orderContext.filterBy;
  const searchBy      = orderContext.searchBy;
  const paymentStatus = orderContext.paymentStatus;
  const orderStatus   = orderContext.orderStatus;
  const timePeriod    = orderContext.timePeriod;
  const searchByValue = orderContext.searchByValue;
  const navigate   = useNavigate();
  const { pageNo } = useParams();
  var pageSelected = 1;
  if(typeof pageNo !== "undefined")
  {
      const parts  = pageNo.split("-");
      pageSelected = parts[1].trim(); 
  }
  const { t } = useTranslation();
  const MyContext = useContext(configurationContext);
  const BASE  = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [isLoading, setIsLoading] = useState(false);
  const [syncIsLoading, setSyncIsLoading] = useState(false);
  const [dataTableData, setDataTableData] = useState({});
  const [responseResultCount, setResponseResultCount] = useState(0);
  const [syncModelOpen, setSyncModelOpen] = useState(false);
  const [syncFromDate, setSyncFromDate] = useState('');
  const [syncToDate, setSyncToDate] = useState('');
  const [orderSyncOn, setOrderSyncOn] = useState('');
  const [syncShopifyOrderID, setSyncShopifyOrderID] = useState('');
  
  const [isOrderContextChanged, setOrderContextChanged] = useState(false);


  useEffect(() => {
    listOrders();
  }, [pageNo]);
   
  const handleResetFilters = () => {
    setOrderContext(dispatch, initialState.orderContext);
    setOrderContextChanged(false);
    if (typeof pageNo === "undefined")
      navigate("/order/list/page-1");
    else
      navigate("/order/list");
  };

  useEffect(() => {
    const hasChanged = Object.keys(orderContext).some(
      key => orderContext[key] !== initialState.orderContext[key]
    );
    setOrderContextChanged(hasChanged);
  }, [orderContext]);
   
   
  const handleSyncModelSubmit = (syncType) => {
    
  let requestPayLoad;
  if(syncType === 'orderid')
  {
    if(syncShopifyOrderID == '')
    {
       toast.error(t('Please enter shopify order ID'));
       return;
    }
    requestPayLoad = {
      orderSyncOn        : '',
      syncFromDate       : '',
      syncToDate         : '',
      syncShopifyOrderID : syncShopifyOrderID,
    };
  }
  else if(syncType === 'date')
  {
    if(orderSyncOn == '')
    {
       toast.error(t('Please select order sync type'));
       return;
    }
    else if(syncFromDate == '')
    {
       toast.error(t('Please select order sync from date'));
       return;
    }
    else if(syncToDate == '')
    {
       toast.error(t('Please select order sync to date'));
       return;
    }

    requestPayLoad = {
      orderSyncOn        : orderSyncOn,
      syncFromDate       : syncFromDate,
      syncToDate         : syncToDate,
      syncShopifyOrderID : '',
    };
  }

  setSyncIsLoading(true);
  axios({
        url     : BASE+"api/order/sync",
        method  : "POST",
        data    : requestPayLoad,
        headers : {
          Authorization   : `Bearer ${TOKEN}`,
          function        : Config.FUNCTION_KEY
        },
      
      }).then(function (response) 
      {       
          const responseData           = response.data;
          const responseDataStatusCode = response.data.status;
          const responseStatusCode     = response.status;

          if(responseStatusCode === 200)
          {
              setSyncIsLoading(false);
              if(responseDataStatusCode === 0)
              toast.error(t(response.data.message));
              else if(responseDataStatusCode === 1)
              toast.success(t(response.data.message));                
              setTimeout(() => {
                navigate( "/order/list" );
                if(typeof pageNo === "undefined")
                {
                  handleSyncModelClose();
                  listOrders();
                }
              }, 3000);
          }    
          else 
          {
            toast.error(t('An unexpected error occurred while communicating with server'));
            return;            
          }    
      }).catch(function (error) {
        setSyncIsLoading(false);
        handleErrors(error, t, navigate);       
      });
  };

  const handleSyncModelClose = () => {
    setSyncModelOpen(false);
    setSyncFromDate('');
    setSyncToDate('');
    setOrderSyncOn('');
    setSyncShopifyOrderID('');
  };

  const handleChangeOrderBy = (event: SelectChangeEvent) => {
    setOrderContext(dispatch, { ...orderContext, orderBy: event.target.value});
  };

  const handleChangeOrderByType = (event: SelectChangeEvent) => {
    setOrderContext(dispatch, { ...orderContext, orderByType: event.target.value});
  }; 

  const handleChangeFilterBy = (event: SelectChangeEvent) => {
    setOrderContext(dispatch, { ...orderContext, 
      filterBy: event.target.value,
      paymentStatus: 'all',
      orderStatus: 'all',
      timePeriod: 'all',  
    });
  };
    
  const handleChangePaymentStatus = (event: SelectChangeEvent) => {
    setOrderContext(dispatch, { ...orderContext, paymentStatus: event.target.value});
  };

  const handleChangeOrderStatus = (event: SelectChangeEvent) => {
    setOrderContext(dispatch, { ...orderContext, orderStatus: event.target.value});
  };

  const handleChangeTimePeriod = (event: SelectChangeEvent) => {
    setOrderContext(dispatch, { ...orderContext, timePeriod: event.target.value});
  };

  const handleChangeSearchBy = (event: SelectChangeEvent) => {
    setOrderContext(dispatch, { ...orderContext, 
      searchBy: event.target.value,
      searchByValue: '',      
    });
  };

  const handleChangeSearchByValue = (event) => {
    setOrderContext(dispatch, { ...orderContext, searchByValue: event.target.value});
  };

  const handleChangeSyncFromDate = (newDateTime) => {
    setSyncFromDate(newDateTime);
  };

  const handleChangeSyncToDate = (newDateTime) => {
    setSyncToDate(newDateTime);
  };

  const handleChangeOrderSyncOn = (event) => {
    setOrderSyncOn(event.target.value);    
  };

  const handleChangeSyncShopifyOrderID = (event) => {
    setSyncShopifyOrderID(event.target.value);        
  };

  const handleKeyPressSearchByValue = (e) => {
    if(searchBy === "orderid" || searchBy === "shopifyorderid")
    {
      // Allow numbers (0-9), backspace, and arrow keys
      if (!/^[0-9\b]+$/.test(e.key)) {
        e.preventDefault();
      }
    }
  };

  const renderOrderByList = (
    <>
      <InputLabel>{t('Order By')}</InputLabel>
      <Select
          id="order-by"
          value={orderBy}
          label={t('Order By')}
          onChange={handleChangeOrderBy}
          className='filterStyle'
        >      
        <MenuItem value='orderid'>{t('Order ID')}</MenuItem>
        <MenuItem value='price'>{t('Price')}</MenuItem>
      </Select>      
    </>
  );

  const renderOrderSyncOnList = (
    <>
      <InputLabel>{t('Order Sync On')}</InputLabel>
      <Select
          id="order-sync-on"
          value={orderSyncOn}
          label={t('Order Sync On')}
          onChange={handleChangeOrderSyncOn}
          className='filterStyle'
        >  
        <MenuItem value="">{t('None')}</MenuItem>    
        <MenuItem value='createddate'>{t('Created Date')}</MenuItem>
        <MenuItem value='processeddate'>{t('Processed Date')}</MenuItem>
      </Select>      
    </>
  );
  
  const renderOrderByType = (
    <>
      <InputLabel>{t('order')}</InputLabel>
      <Select
          id="order-by-type"
          value={orderByType}
          label={t('order')}
          onChange={handleChangeOrderByType}
          className='filterStyle'
        >      
        <MenuItem value='desc'>{t('Desc')}</MenuItem>
        <MenuItem value='asc'>{t('Asc')}</MenuItem>
      </Select>      
    </>
  );

  const renderFilterByList = (
    <>
      <InputLabel>{t('Filter By')}</InputLabel>
      <Select
          id="filter-by"
          value={filterBy}
          label={t('Filter By')}
          onChange={handleChangeFilterBy}
          className='filterStyle'
        >      
        <MenuItem value="none">{t('None')}</MenuItem>
        <MenuItem value="payment">{t('Payment Status')}</MenuItem>
        <MenuItem value="order">{t('Order Status')}</MenuItem>
        <MenuItem value="date">{t('Date')}</MenuItem>
      </Select>      
    </>
  );


  const renderPaymentStatusList = (
    <>
      <InputLabel>{t('Payment Status')}</InputLabel>
      <Select
          id="payment-status"
          value={paymentStatus}
          label={t('Payment Status')}
          onChange={handleChangePaymentStatus}
          className='filterStyle'
        >      
        <MenuItem value='all'>{t('All')}</MenuItem>
        <MenuItem value='paid'>{t('Paid')}</MenuItem>
        <MenuItem value='pending'>{t('Pending')}</MenuItem>
        <MenuItem value='refunded'>{t('Refunded')}</MenuItem>
        <MenuItem value='voided'>{t('Voided')}</MenuItem>        
      </Select>      
    </>
  );


  const renderOrderStatusList = (
    <>
      <InputLabel>{t('Order Status')}</InputLabel>
      <Select
          id="order-status"
          value={orderStatus}
          label={t('Order Status')}
          onChange={handleChangeOrderStatus}
          className='filterStyle'
        >      
        <MenuItem value='all'>{t('All')}</MenuItem>
        <MenuItem value='open'>{t('Open')}</MenuItem>
        <MenuItem value='accepted'>{t('Accepted')}</MenuItem>
        <MenuItem value='rejected'>{t('Rejected')}</MenuItem>
        <MenuItem value='partially_fulfilled'>{t('Partially Fulfilled')}</MenuItem>
        <MenuItem value='fulfilled'>{t('Fulfilled')}</MenuItem>
      </Select>      
    </>
  );


  const renderTimePeriodList = (
    <>
      <InputLabel>{t('Time Period')}</InputLabel>
      <Select
          id="time-period"
          value={timePeriod}
          label={t('Time Period')}
          onChange={handleChangeTimePeriod}
          className='filterStyle'
        >      
        <MenuItem value='all'>{t('All Time')}</MenuItem>
        <MenuItem value='today'>{t('Today')}</MenuItem>
        <MenuItem value='yesterday'>{t('Yesterday')}</MenuItem>
        <MenuItem value='last7days'>{t('Last 7 Days')}</MenuItem>
        <MenuItem value='last14days'>{t('Last 14 Days')}</MenuItem>
        <MenuItem value='last30days'>{t('Last 30 Days')}</MenuItem>
      </Select>      
    </>
  );

  const renderSearchByList = (
    <>
      <InputLabel>{t('Search By')}</InputLabel>
      <Select
          id="search-by"
          value={searchBy}
          label={t('Search By')}
          onChange={handleChangeSearchBy}
          className='filterStyle'
        >      
        <MenuItem value="none">{t('None')}</MenuItem>
        <MenuItem value="orderid">{t('Order ID')}</MenuItem>
        <MenuItem value="shopifyorderid">{t('Shopify Order ID')}</MenuItem>
        <MenuItem value="vendor">{t('vendor')}</MenuItem>
      </Select>      
    </>
  );

  const listOrders = () => {
    setIsLoading(true);
    const requestPayLoad = {
        orderBy       : orderBy,
        orderByType   : orderByType,
        filterBy      : filterBy,
        searchBy      : searchBy,
        paymentStatus : paymentStatus,
        orderStatus   : orderStatus,
        timePeriod    : timePeriod,
        searchByValue : searchByValue,
        pageSelected  : pageSelected
    };
   
    axios({
          url     : BASE+"api/order/list",
          method  : "POST",
          data    : requestPayLoad,
          headers : {
            Authorization   : `Bearer ${TOKEN}`,
            function        : Config.FUNCTION_KEY
          },
        
        }).then(function (response) 
        {
            const responseData           = response.data;
            const responseDataStatusCode = response.data.status;
            const responseStatusCode     = response.status;

            if(responseStatusCode === 200)
            {
                setIsLoading(false);
                if(responseDataStatusCode === 0)
                {
                    toast.error(t('An unexpected error occurred while communicating with server'));
                    return;    
                }
                else if(responseDataStatusCode === 1 && responseData.data && responseData.data.rows)
                {
                    const columns  =  [
                      { Header: `${t("Order ID")}`, accessor: "vendorOrderID", align: "left"},
                      { Header: `${t("Store Order ID")}`, accessor: "storeOrderID", align: "left" },
                      { Header: `${t("Shopify Order ID")}`, accessor: "shopifyOrderID", align: "left" },
                      { Header: `${t("vendor")}`, accessor: "vendor", align: "left" },
                      { Header: `${t("Price")}`, accessor: "totalPrice", align: "right"},
                      { Header: `${t("Payment Mode")}`,accessor: "paymentMode", align: "left" },
                      { Header: `${t("Payment Status")}`, accessor: "paymentStatus", align: "left" },
                      { Header: `${t("Order Status")}`, accessor: "orderStatus", align: "left" },
                      { Header: `${t("Date")}`, accessor: "date", align: "left" },
                      { Header: `${t("Action")}`, accessor: "action", align: "left" }
                    ];
                                     
                    var rows = [];
                                        
                    responseData.data.rows.map((item, index) => {

                        let paymentStatusBox;
                        let orderStatusBox;

                        if(item.orderStatus === 'open')
                        orderStatusBox = <Box className="orderStatusBoxOpen">{t(item.orderStatus)}</Box>
                        else if(item.orderStatus === 'accepted')
                        orderStatusBox = <Box className="orderStatusBoxAccepted">{t(item.orderStatus)}</Box>
                        else if(item.orderStatus === 'rejected')
                        orderStatusBox = <Box className="orderStatusBoxRejected">{t(item.orderStatus)}</Box>
                        else if(item.orderStatus === 'partially fulfilled')
                        orderStatusBox = <Box className="orderStatusBoxPartiallyFulfilled">{t(item.orderStatus)}</Box>
                        else 
                        orderStatusBox = <Box className="orderStatusBoxFulfilled">{t(item.orderStatus)}</Box>


                        if(item.paymentStatus === 'pending')
                        paymentStatusBox = <Box className="paymentStatusBoxPending">{t(item.paymentStatus)}</Box>
                        else if(item.paymentStatus === 'refunded')
                        paymentStatusBox = <Box className="paymentStatusBoxRefunded">{t(item.paymentStatus)}</Box>
                        else if(item.paymentStatus === 'voided')
                        paymentStatusBox = <Box className="paymentStatusBoxVoided">{t(item.paymentStatus)}</Box>
                        else 
                        paymentStatusBox = <Box className="paymentStatusBoxPaid">{t(item.paymentStatus)}</Box>

                        var tempData = {
                          "vendorOrderID"     : item.vendorOrderID,
                          "storeOrderID"      : <Box>{"#"+item.storeOrderID}</Box>,
                          "shopifyOrderID"    : item.shopifyOrderID,
                          "vendor"            : <Box className="vendorBox">{item.vendor}</Box>,
                          "totalPrice"        : item.totalPrice.toFixed(2),
                          "paymentMode"       : <Box className="paymentModeBox">{item.paymentMode}</Box>,
                          "paymentStatus"     : paymentStatusBox,
                          "orderStatus"       : orderStatusBox,
                          "date"              : item.date,
                          "action"            : <Link href={"#"} onClick={(event) => { event.preventDefault(); navigate("/order/details/"+item.vendorOrderID) }} ><Box className="squareBoxView"><VisibilityIcon color="primary" fontSize="medium" titleAccess={t("View")} /></Box></Link>,
                        };                        

                      rows.push(tempData);
                    });

                    setDataTableData({ columns, rows });
                    setResponseResultCount(responseData.data.totalCount);
                }
            }   
            else 
            {
              toast.error(t('An unexpected error occurred while communicating with server'));
              return;            
            }          

        }).catch(function (error) {
          setIsLoading(false);
          handleErrors(error, t, navigate);    
        });      
  }
   
  const loadSyncOption = () => {
        setSyncModelOpen(true);
  }

  const syncModelLoad = () => {

    return (  
        <Dialog open={syncModelOpen} onClose={handleSyncModelClose}>      
          <DialogTitle id="sync-orders-dialog" onClose={handleSyncModelClose}>
            {t("Sync Orders")}  
          </DialogTitle>
          <DialogContent dividers>
            <Typography variant="h6">
              {t("Method 1")}
            </Typography>
            <Typography variant="body2"  className='generalFont12'>
              {t("Method 1 Label")}
            </Typography>
            <Grid container spacing={2} my={1}>
              <Grid item sm={6} xs={12}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MobileDateTimePicker 
                        label={t("From")} 
                        value={syncFromDate}
                        onChange={handleChangeSyncFromDate}
                    />
                </LocalizationProvider>
              </Grid>
              <Grid item sm={6} xs={12}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MobileDateTimePicker 
                        label={t("To")} 
                        value={syncToDate}
                        onChange={handleChangeSyncToDate}
                    />
                </LocalizationProvider>
              </Grid>
            </Grid>

            <FormControl className='formControlOrderSyncOn'>
              {renderOrderSyncOnList}
              <Icon className='keyboardArrowDown'>keyboard_arrow_down</Icon>
            </FormControl>
            
            <Container className="buttonContainer">
                <Box>
                  <Button                     
                    variant="contained" 
                    className='orderSyncButton'
                    onClick={() => handleSyncModelSubmit('date')}
                    disabled={syncIsLoading}
                    disableRipple
                    >
                    {t("Sync")}                    
                  </Button>
                  <Button                     
                    variant="contained" 
                    className='orderSyncCancelButton'
                    onClick={handleSyncModelClose}
                    disabled={syncIsLoading}
                    disableRipple
                    >
                    {t("Cancel")}
                  </Button>
                </Box>
            </Container>

            <div>
              <Typography variant="body2" className='generalFont'>
                {t("Note")}
              </Typography>

              <Typography variant="body2" className='generalFont12'>
                {t("Note Label")}
              </Typography>

              <Typography variant="body2" className='generalFont12'>
                {t("Created Date Label")}
              </Typography>

              <Typography variant="body2" className='generalFont12'>
                {t("Processed Date Label")}
              </Typography>
            </div>
        
          </DialogContent>

          {syncIsLoading ?       
            <Backdrop sx={{ color: '#FFFFFF', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={syncIsLoading}>
              <CircularProgress color="inherit" />
            </Backdrop>
          : <></>}

          <DialogContent dividers>
              <Typography variant="h6">
                {t("Method 2")}
              </Typography>

              <Typography variant="body2" className='generalFont12'>
                {t("Method 2 Label")}
              </Typography>

              <FormControl className='formcontrolShopifyOrderId'>
                <TextField 
                  label = {t('Shopify Order ID')}
                  variant = "outlined" 
                  value = {syncShopifyOrderID}
                  onChange={handleChangeSyncShopifyOrderID}
                />
              </FormControl>
              <Typography variant="body2" className='generalFont12'>
                {t("Order ID separated with comma")}
              </Typography>

              <Container className="buttonContainer">
                <Box>
                  <Button                     
                    variant="contained" 
                    className='orderSyncButton' 
                    onClick={() => handleSyncModelSubmit('orderid')}
                    disabled={syncIsLoading}
                    disableRipple
                    >
                    {t("Sync")}                    
                  </Button>

                  <Button                     
                    variant="contained" 
                    className='orderSyncCancelButton'
                    onClick={handleSyncModelClose}
                    disabled={syncIsLoading}
                    disableRipple
                    >
                    {t("Cancel")}                    
                  </Button>
                </Box>
              </Container>
            </DialogContent>
        </Dialog>      
      );
  }
  
  return (
      <DashboardLayout>
        <DashboardNavbar pageTitle={t('All Orders')} />
        <MDBox my={3} className="ContentSectionBox">
          {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && checkPrivilege("order", "write"))) ?
            <MDBox display="flex" justifyContent="flex-end" mb={2}>
                <MDBox ml={1}>
                  <Button 
                        variant="contained" 
                        onClick= { loadSyncOption } 
                        className='syncOrderButton'
                        disableRipple
                      >{t('Sync Orders')}
                  </Button>
                </MDBox>            
            </MDBox>
          : null}

          {isLoading ? (
              <Backdrop sx={{ color: '#FFFFFF', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
                <CircularProgress color="inherit" />
              </Backdrop>
          ) : <></> }


          {syncModelOpen ? syncModelLoad() : <></>}
                 
          <MDBox className="ManageProductTopSec" mx={2}
                  mt={0}
                  py={3}
                  px={2}
                  variant="gradient">

          <Grid container className="FilterSectionBox" spacing={2} 
            sx={filterBy !== "none" && searchBy !== "none" ? { justifyContent: 'center' } : {}}
          >            
    
              <Grid item className="FilterSectionInnerBox" md={2} sm={3} xs={6}>
                <FormControl className='formcontrolFilterStyle'>
                  {renderFilterByList}
                  <Icon className='keyboardArrowDown'>keyboard_arrow_down</Icon>
                </FormControl>
              </Grid>

            {filterBy === "payment" ?
              <Grid item className="FilterSectionInnerBox" md={2} sm={3} xs={6}>
                <FormControl className='formcontrolFilterStyle'>
                  {renderPaymentStatusList}
                  <Icon className='keyboardArrowDown'>keyboard_arrow_down</Icon>
                </FormControl>
              </Grid>  
            : <></>}

            {filterBy === "order" ?
            <Grid item className="FilterSectionInnerBox" md={2} sm={3} xs={6}>
              <FormControl className='formcontrolFilterStyle'>
                {renderOrderStatusList}
                <Icon className='keyboardArrowDown'>keyboard_arrow_down</Icon>
              </FormControl>
            </Grid> 
            : <></>}

            {filterBy === "date" ?
            <Grid item className="FilterSectionInnerBox" md={2} sm={3} xs={6}>
              <FormControl className='formcontrolFilterStyle'>
                {renderTimePeriodList}
                <Icon className='keyboardArrowDown'>keyboard_arrow_down</Icon>
              </FormControl>
            </Grid> 
            : <></>}

            <Grid item className="FilterSectionInnerBox" md={2} sm={3} xs={6}>  
              <FormControl className='formcontrolFilterStyle'>
                {renderSearchByList}
                <Icon className='keyboardArrowDown'>keyboard_arrow_down</Icon>
              </FormControl>
            </Grid> 

            {(searchBy != "none") ?
              <Grid item className="FilterSectionInnerBox" md={2} sm={3} xs={6}>  
                <FormControl className='formcontrolFilterStyle'>

                  <InputLabel className='SearchInputHead'>{t('Search Input')}</InputLabel>
                  <TextField                     
                    variant = "outlined" 
                    value = {searchByValue}
                    onChange={handleChangeSearchByValue}
                    onKeyPress={handleKeyPressSearchByValue}         
                  />
                </FormControl>
              </Grid> 
              :<></>
            }

            <Grid item className="FilterSectionInnerBox" md={2} sm={3} xs={6}>
                <FormControl className='formcontrolFilterStyle'>
                  {renderOrderByList}
                  <Icon className='keyboardArrowDown'>keyboard_arrow_down</Icon>
                </FormControl>
            </Grid>  

            <Grid item className="FilterSectionInnerBox" md={2} sm={3} xs={6}>
              <FormControl className='formcontrolFilterStyle'>
                {renderOrderByType}
                <Icon className='keyboardArrowDown'>keyboard_arrow_down</Icon>
              </FormControl>
            </Grid>

            <Grid item md={2} sm={3} xs={6} className="actionGrid">  
              <FormControl className="filterSubmit">
                  <MDButton
                      key="submit" type="submit" color="info" size="small" className="SubmitButton" disableRipple

                    onClick={() => {
                      navigate( "/order/list" );
                      if(typeof pageNo === "undefined")
                      listOrders();
                    }}
                  >
                   {t('Submit')}                  
                  </MDButton>
                  
                  
                  {isOrderContextChanged && (
                    <MDButton onClick={handleResetFilters} key="reset" type="submit" color="info" size="small" className="ResetButton" disableRipple fullWidth>{t('reset')}</MDButton>
                  )}
                  
              </FormControl>              

           


            </Grid> 
          </Grid>
          </MDBox>
          <MDBox pt={3} className='dataTableMDBox'>
            {dataTableData.columns && dataTableData.columns.length > 0 ?
              <DataTable 
                table={dataTableData} 
                isSorted={false}
                showTotalEntries={true}
                responseResultCount={responseResultCount}
                paginationSize = {MyContext.paginationSize}
                paginationLink = {"/order/list/page-"}
                pageSelected = {pageSelected}
              />
            : <></>}
          </MDBox>
         
        </MDBox>
      </DashboardLayout>
  );
}

export default List;
